import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';
import { getToken } from '../../Utils/authUtils';

interface DismissReminderPayload {
  reportId: string;
}

export const dismissReminder = createAsyncThunk(
  'reports/dismissReminder',
  async (payload: DismissReminderPayload, { rejectWithValue }) => {
    try {
      const token = getToken();
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      };
      const res = await fetch(REPORTS.DISMISS_REMINDER, requestOptions);

      if (!res.ok) {
        const errorData = await res.json();
        return rejectWithValue(errorData.msg || 'Failed to dismiss reminder');
      }

      const data = await res.json();
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to dismiss reminder');
    }
  }
);
